import type { FC } from "react";

import { ExternalLinkIcon } from "@jti/brand-icons/external-link";
import type { LinkBehaviourProps } from "@jti/core-components/components/LinkBehaviour";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./StoreLocatorGetDirection.module.scss";

type StoreLocatorGetDirectionProps = {
  isLinkLabel?: boolean;
} & LinkBehaviourProps;

export const StoreLocatorGetDirection: FC<StoreLocatorGetDirectionProps> = ({ isLinkLabel = true, ...rest }) => {
  const { __ } = useTranslations();
  const label = __("store_locator.popup.get_directions");

  return (
    <LinkBehaviour
      data-testid="storeLocatorCardGetDirections"
      className={styles.directionCta}
      aria-label={isLinkLabel ? undefined : label}
      rel="noreferrer"
      target="_blank"
      {...rest}
    >
      <ExternalLinkIcon aria-hidden="true" height="20px" width="20px" className={styles.directionIcon} />
      {isLinkLabel && <span>{label}</span>}
    </LinkBehaviour>
  );
};
